import InlineSVG from 'svg-inline-react';

import pillHeart from 'public/pill-heart-animated.svg';

import styles from './styles.module.scss';

export const HeartAnimation = () => (
  <div className={styles.pillHeart}>
    <InlineSVG src={pillHeart} />
  </div>
);
